<template>
    <footer>
        <div class="container">
            <a href="https://www.facebook.com/%E8%BF%B7%E9%BA%8B-100351884686547/" target="_blank">
                <i class="fab fa-facebook-square"></i>
            </a>
            <a href="https://www.instagram.com/mi.me____/" target="_blank">
                <i class="fab fa-instagram"></i>
            </a>
            <p>世新大學資訊傳播學系<br/>© 迷‧糜 2019</p>
        </div>
    </footer>
</template>

<script>

export default {
    name:'Footer'
}
</script>

<style>
    html,body{
        margin: 0;
        background-color: #598392;
        font-family: '微軟正黑體';
        color: #598392;
    }
    footer{
        background-color: rgba(255,255,255,0.8);
        text-align: center;
        padding: 20px 0px 5px 0px;
        margin-top: 40px;
    }

    footer i{
        padding: 0px 15px 15px 15px;
        font-size: 40px;
        color: #598392;
    }
    footer p{
        text-align: center;
        font-family: '微軟正黑體';
        margin-bottom: 0;
        
    }
    
</style>


// WEBPACK FOOTER //
// src/components/shared/Footer.vue